/** Fallback copy when an assistant turn ends with no visible bubble content. */

export function inferAssistantFallback(message) {
  const steps = message?.pipeline_trace?.steps;
  if (!Array.isArray(steps) || !steps.length) {
    return "I couldn't generate a response. Please try again.";
  }

  const failed = steps.find(
    (s) => s?.status === 'error' || s?.detail?.error || s?.detail?.message,
  );
  if (failed) {
    const detail = failed.detail?.error || failed.detail?.message || failed.title;
    if (detail) return `Something went wrong: ${detail}`;
  }

  const toolSteps = steps.filter((s) => s?.id === 'agent_tool');
  if (toolSteps.length) {
    return (
      "I couldn't complete that booking step. There may be no direct route between those stations, "
      + "or a station may only allow boarding or drop-off in one direction. "
      + "Try Dubai to Abu Dhabi, Fujairah to Sharjah, or Al Ain to Al Ghubaiba."
    );
  }

  return "I couldn't generate a response. Please try again.";
}

export function assistantMessageNeedsFallback(message) {
  if (!message || message.role !== 'assistant' || message.streaming) return false;
  const text = String(message.content || '').trim();
  if (text) return false;
  if ((message.ui_parts || []).length) return false;
  if (message.pipeline_trace?.steps?.length) return true;
  return false;
}
